import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowClose, faTrash } from "@fortawesome/free-solid-svg-icons";

import { useInput } from "../../../shared/hooks/form-fields";
import { Select, Textarea } from "../../form-inputs/inputs";
import { EDITING_SOURCE_MAP } from "components/photography/lib/helpers";
import Modal from "../../modal";
import { Task } from "../../../shared/taskTypeMap";
import * as notify from "../../../shared/notify";

const RejectReason = ({ shot, update, rejectReasons, isQA, onRemoveRejectReason, isCompleted }) => {
    const [showReason, setShowReason] = useState(false);
    const [additionalInfo, setAdditionalInfo] = useState("");
    const [isAdditionalInfoRequired, setIsAdditionalInfoRequired] = useState(false);
    const selectReason = useInput(shot.editingJobFileRejectTypeId || "");
    const isMarkedForReject = !!shot.editingJobFileRejectTypeId;

    useEffect(() => {
        if (selectReason.value) {
            const index = rejectReasons.findIndex(
                ({ isRejectionReasonRequired, value }) => isRejectionReasonRequired && value.toString() === selectReason.value
            );

            setIsAdditionalInfoRequired(index !== -1);
        }
    }, [selectReason.value, rejectReasons]);

    useEffect(() => {
        if (shot.editingJobFileRejectTypeId !== selectReason.value) {
            selectReason.setValue(shot.editingJobFileRejectTypeId);
        }
    }, [shot.editingJobFileRejectTypeId]);

    const handleCloseModal = () => {
        setShowReason(!showReason);
    };

    const showRejectModal = () => {
        return isQA && !isCompleted && shot.imageView !== Task.CODING && shot.editingSourceId !== EDITING_SOURCE_MAP["skipEditing"] && shot.imageView;
    };

    const getRejectReason = () => {
        const selectedReason = rejectReasons.find(({ value }) => value.toString() === selectReason.value);

        return selectedReason ? `${selectedReason.text}:` : "";
    };

    const handleSaveRejectReason = () => {
        if (!selectReason.value) {
            notify.error("Reject reason must be selected");

            return;
        }

        update(shot.key, selectReason.value, additionalInfo, getRejectReason());
        setShowReason(!showReason);
    };

    const handleClearRejectReason = () => {
        setAdditionalInfo("");
        onRemoveRejectReason(shot.key);
    };

    if (isMarkedForReject) {
        return (
            <div className="reject-reason flex-1 flex-column align-items-end p-l-16">
                <div className="flex align-items-center m-b-12">
                    <span className={`${isQA && !isCompleted ? "m-r-12" : ""} memo`}>Marked for Rejection</span>
                    {isQA && !isCompleted && (
                        <div
                            className="button -secondary -text"
                            onClick={handleClearRejectReason}
                        >
                            <FontAwesomeIcon icon={faTrash} />
                        </div>
                    )}
                </div>
                <div className="memo-bold">{shot.editingJobRejectText}</div>
                <div className="memo-italic txt-wrap">{shot.editingJobCustomRejectText}</div>
            </div>
        );
    }

    return (
        <div className="reject-reason button-group">
            <Modal
                show={showReason}
                onClose={handleCloseModal}
            >
                <h3>Reject Asset (send back to BrightRiver)</h3>
                <Select
                    label="Select reason"
                    options={rejectReasons}
                    {...selectReason.bind}
                    stopAutoSelect={true}
                    disabled={!isQA}
                />
                <Textarea
                    required={isAdditionalInfoRequired}
                    name="additionalInfo"
                    placeholder="Enter additional reject reason"
                    label="Additional reject details"
                    rows="3"
                    value={additionalInfo}
                    updateOnChange={(name, value) => setAdditionalInfo(value)}
                />
                <div className="button-group justify-content-end m-t-16">
                    <button
                        className="button"
                        onClick={handleCloseModal}
                    >
                        Cancel
                    </button>
                    <button
                        disabled={isAdditionalInfoRequired ? additionalInfo.length === 0 : !selectReason.value}
                        className="button -primary"
                        onClick={handleSaveRejectReason}
                    >
                        Confirm
                    </button>
                </div>
            </Modal>
            {showRejectModal() && (
                <div
                    className="button -text"
                    onClick={handleCloseModal}
                >
                    <FontAwesomeIcon icon={faWindowClose} />
                </div>
            )}
        </div>
    );
};

export default RejectReason;
